// src/components/Preloader.js
import React from 'react';

const Preloader = () => {
    return (
        <div className="preloader text-center vh-50">
            <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
};

export default Preloader;
